import { sanitize } from "dompurify";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getPost } from "../rest/RestAPI";
import "../css/Article.css";

export default function Article() {
    const { slug } = useParams();
    const [article, setArticle] = useState({});
    useEffect(() => {
    async function fetchArticle() {
      const res = await getPost(slug);
      setArticle(res[0]);
    }
    fetchArticle();
    }, [slug]);
    return(
        <div className="Article">
            {!(article && Object.keys(article).length === 0 && article.constructor === Object) && 
                <div>
                    <h1 className="articleTitle" dangerouslySetInnerHTML={{__html: sanitize(article.title.rendered)}}></h1>
                    <img src={article._embedded["wp:featuredmedia"][0].source_url} alt="img" />
                    <div className="articleContent" dangerouslySetInnerHTML={{__html: sanitize(article.content.rendered)}}></div>
                </div>}
        </div>
    );
}